<app-breadcrumb
  *ngIf="!mod"
  [master]="'Dobry Agent'"
  [parentName]="'Artykuły'"
  [name]="isEditMode ? 'Edytuj' : 'Dodaj'"
></app-breadcrumb>

<div class="articles-add-container" fxLayout="column" fxLayoutGap="15px">

  <div *ngIf="loading" class="da-article-form-loader">
    <mat-spinner diameter="36"></mat-spinner>
  </div>

  <form
    *ngIf="!loading"
    #articleForm="ngForm"
    class="da-article-form"
    (ngSubmit)="save(articleForm)"
    fxLayout="column"
    fxFlex="100"
    fxFlex.lt-md="100"
    fxLayoutGap="15px"
  >
    <div fxLayout="row" fxFlex="100" fxLayoutGap="15px">

      <button
        mat-raised-button
        color="primary"
        type="submit"
        [disabled]="saving"
      >
        <mat-icon>save</mat-icon>
        <span>{{ saving ? ' Zapisywanie...' : ' Zapisz' }}</span>
      </button>

      <button
        *ngIf="!isEditMode && !mod"
        mat-raised-button
        color="accent"
        type="button"
        (click)="save(articleForm, true)"
        [disabled]="saving"
      >
        <mat-icon>save</mat-icon>
        <span> Zapisz i dodaj kolejny</span>
      </button>

      <button
        mat-stroked-button
        type="button"
        (click)="cancel()"
        [disabled]="saving"
        color="warn"
      >
        <mat-icon>cancel</mat-icon>
        <span>{{ mod ? ' Zamknij' : ' Anuluj' }}</span>
      </button>
    </div>

    <div
      class="article-form-columns"
      fxLayout="row"
      fxLayoutGap="15px"
      fxFlex="100"
      fxLayout.lt-lg="column"
    >
      <mat-card
        class="article-form-card"
        fxLayout="column"
        fxFlex="50"
        fxFlex.lt-lg="100"
      >
        <app-section-header
          [title]="isEditMode ? 'Edytuj artykuł' : 'Dodaj artykuł'"
          [description]="
    isEditMode
      ? 'Zmień treść i ustawienia publikacji artykułu.'
      : 'Uzupełnij treść i ustawienia publikacji artykułu.'
  "
        ></app-section-header>

        <mat-form-field>
          <mat-label>Nazwa artykułu</mat-label>
          <input
            matInput
            name="name"
            required
            maxlength="255"
            placeholder="Np. Jak wybrać ubezpieczenie?"
            [(ngModel)]="model.name"
            #name="ngModel"
            (ngModelChange)="clearBackendError(articleForm, 'name')"
          >

          <mat-error *ngIf="name.errors?.required && name.touched">
            Nazwa artykułu jest wymagana.
          </mat-error>

          <mat-error *ngIf="name.errors?.backend && name.touched">
            {{ name.errors.backend }}
          </mat-error>
        </mat-form-field>
        <div fxLayout="column" fxLayoutGap="8px" style="margin-bottom: 15px">
          <label class="editor-label">Obrazek artykułu</label>

          <div *ngIf="selectedImageFileName" class="selected-file-name">
            Wybrany plik: {{ selectedImageFileName }}
          </div>

          <div *ngIf="selectedImagePreview">
            <img
              class="article-current-image"
              [src]="selectedImagePreview"
              [alt]="model.altImage || 'Obrazek artykułu'"
            >
          </div>

          <div *ngIf="isEditMode && getCurrentArticleImage() && !selectedImagePreview">
            <img
              class="article-current-image"
              [src]="getCurrentArticleImage()"
              [alt]="model.altImage || 'Obrazek artykułu'"
            >
          </div>

          <div fxLayout="row" fxLayoutGap="15px" fxLayoutAlign="start center">
            <input
              #imageInput
              type="file"
              accept="image/*"
              hidden
              (change)="onImageSelected($event)"
            >

            <button
              mat-stroked-button
              color="primary"
              type="button"
              (click)="imageInput.click()"
              [disabled]="saving"
            >
              <mat-icon>upload</mat-icon>
              <span>{{ getCurrentArticleImage() ? 'Zmień obrazek' : 'Wybierz obrazek' }}</span>
            </button>

            <button
              *ngIf="selectedImageFile"
              mat-stroked-button
              color="warn"
              type="button"
              (click)="clearSelectedImage(imageInput)"
              [disabled]="saving"
            >
              <mat-icon>close</mat-icon>
              <span>Usuń</span>
            </button>
          </div>
        </div>
        <mat-form-field>
          <mat-label>Alt obrazka</mat-label>
          <input
            matInput
            name="altImage"
            required
            maxlength="255"
            [(ngModel)]="model.altImage"
            #altImage="ngModel"
            (ngModelChange)="clearBackendError(articleForm, 'altImage')"
          >

          <mat-error *ngIf="altImage.errors?.required && altImage.touched">
            Alt obrazka jest wymagany.
          </mat-error>

          <mat-error *ngIf="altImage.errors?.backend && altImage.touched">
            {{ altImage.errors.backend }}
          </mat-error>
        </mat-form-field>

        <div fxLayout="row" fxLayout.lt-md="column" fxLayoutGap="15px">
          <mat-form-field fxFlex="33">
            <mat-label>Pozycja</mat-label>
            <input
              matInput
              type="number"
              name="position"
              required
              [(ngModel)]="model.position"
              #position="ngModel"
              (ngModelChange)="clearBackendError(articleForm, 'position')"
            >

            <mat-error *ngIf="position.errors?.required && position.touched">
              Pozycja jest wymagana.
            </mat-error>

            <mat-error *ngIf="position.errors?.backend && position.touched">
              {{ position.errors.backend }}
            </mat-error>
          </mat-form-field>
          <div  fxLayout="column"   fxLayoutGap="8px">
            <app-datepicker
              fxFlex="33"
              class="employee-list-filter"
              label="Data publikacji"
              placeholder="2000-01-01"
              [required]="true"
              [(ngModel)]="model.publicationDate"
              name="publicationDate"
              #publicationDate="ngModel"
              (ngModelChange)="clearBackendError(articleForm, 'publicationDate')"
            ></app-datepicker>

            <mat-error
              *ngIf="publicationDate.errors?.required && publicationDate.touched"
            >
              Data publikacji jest wymagana.
            </mat-error>
          </div>

          <mat-error
            *ngIf="publicationDate.errors?.backend && publicationDate.touched"
          >
            {{ publicationDate.errors.backend }}
          </mat-error>
          <mat-slide-toggle
            fxFlex="33"
            color="accent"
            name="active"
            [(ngModel)]="model.active"
          >
            Aktywny
          </mat-slide-toggle>
        </div>

        <mat-form-field appearance="outline">
          <mat-label>Krótki opis</mat-label>
          <textarea
            matInput
            name="shortDescription"
            required
            maxlength="200"
            rows="4"
            [(ngModel)]="model.shortDescription"
            #shortDescription="ngModel"
            (ngModelChange)="clearBackendError(articleForm, 'shortDescription')"
          ></textarea>

          <mat-hint align="end">
            {{ model.shortDescription?.length || 0 }}/200
          </mat-hint>

          <mat-error *ngIf="shortDescription.errors?.required && shortDescription.touched">
            Krótki opis jest wymagany.
          </mat-error>

          <mat-error *ngIf="shortDescription.errors?.backend && shortDescription.touched">
            {{ shortDescription.errors.backend }}
          </mat-error>
        </mat-form-field>

        <div
          [formGroup]="articleReactiveForm"
          fxLayout="column"
          fxLayoutGap="8px"
        >
          <label class="editor-label">Treść artykułu</label>

          <angular-editor
            formControlName="description"
            [config]="editorConfig"
            (ngModelChange)="clearDescriptionBackendError()"
          ></angular-editor>

          <mat-error
            *ngIf="articleReactiveForm.get('description')?.errors?.required && articleReactiveForm.get('description')?.touched"
          >
            Treść artykułu jest wymagana.
          </mat-error>

          <mat-error
            *ngIf="articleReactiveForm.get('description')?.errors?.backend && articleReactiveForm.get('description')?.touched"
          >
            {{ articleReactiveForm.get('description')?.errors?.backend }}
          </mat-error>
        </div>


      </mat-card>

      <div fxLayout="column" fxFlex="50" fxFlex.lt-lg="100" fxLayoutGap="15px">
        <mat-card fxLayout="column">
          <app-section-header
            title="Powiązania"
            [description]="
    isEditMode
      ? 'Zmień kategorie, autora i pozostałe powiązania artykułu.'
      : 'Ustaw kategorie, autora i pozostałe powiązania artykułu.'
  "
          ></app-section-header>
          <div fxLayout="row" fxLayout.lt-md="column" fxLayoutGap="15px">
            <app-dict-dobry-agent-blog-categories
              fxFlex="50"
              label="Kategoria"
              [multiple]="false"
              [required]="true"
              [control]="getBlogCategoryControl()"
            >
            </app-dict-dobry-agent-blog-categories>
            <app-dict-dobry-agent-categories
              fxFlex="50"
              label="Kategoria ubezpieczenia"
              [multiple]="false"
              [required]="false"
              [control]="getInsuranceCategoryControl()"
            >
            </app-dict-dobry-agent-categories>
          </div>

          <app-dict-dobry-agent-blog-authors
            fxFlex="50"
            label="Autor"
            [multiple]="false"
            [required]="true"
            [control]="getAuthorControl()"
          >
          </app-dict-dobry-agent-blog-authors>
          <div fxFlex="100">
            <app-dict-dobry-agent-facilities
              label="Powiązana placówka"
              [control]="getRelatedFacilityControl()"
              [multiple]="false"
              [required]="false"
              [returnKey]="true">
            </app-dict-dobry-agent-facilities>
          </div>
          <app-dict-dobry-agent-blog-articles
            label="Powiązany artykuł"
            [multiple]="true"
            [required]="false"
            [control]="getRelatedBlogArticleControl()"
            [excludeUuid]="uuid || null"
          >
          </app-dict-dobry-agent-blog-articles>
          <app-dict-dobry-agent-blog-tags
            label="Tagi"
            [required]="false"
            [control]="getBlogTagsControl()"
          >
          </app-dict-dobry-agent-blog-tags>

        </mat-card>

        <mat-card fxLayout="column">
          <app-section-header
            title="SEO"
            [description]="
    isEditMode
      ? 'Zmień dane wykorzystywane w wynikach wyszukiwania.'
      : 'Uzupełnij dane wykorzystywane w wynikach wyszukiwania.'
  "
          ></app-section-header>

          <mat-form-field>
            <mat-label>Slug SEO</mat-label>
            <input
              matInput
              name="seoSlug"
              required
              maxlength="255"
              [(ngModel)]="model.seoSlug"
              #seoSlug="ngModel"
              (ngModelChange)="clearBackendError(articleForm, 'seoSlug')"
            >

            <mat-error *ngIf="seoSlug.errors?.required && seoSlug.touched">
              Slug jest wymagany.
            </mat-error>

            <mat-error *ngIf="seoSlug.errors?.backend && seoSlug.touched">
              {{ seoSlug.errors.backend }}
            </mat-error>
          </mat-form-field>

          <mat-form-field>
            <mat-label>Tytuł SEO</mat-label>
            <input
              matInput
              name="seoTitle"
              required
              maxlength="255"
              [(ngModel)]="model.seoTitle"
              #seoTitle="ngModel"
              (ngModelChange)="clearBackendError(articleForm, 'seoTitle')"
            >

            <mat-error *ngIf="seoTitle.errors?.required && seoTitle.touched">
              Tytuł SEO jest wymagany.
            </mat-error>

            <mat-error *ngIf="seoTitle.errors?.backend && seoTitle.touched">
              {{ seoTitle.errors.backend }}
            </mat-error>
          </mat-form-field>

          <mat-form-field appearance="outline">
            <mat-label>Opis SEO</mat-label>
            <textarea
              matInput
              name="seoDescription"
              required
              maxlength="320"
              rows="4"
              [(ngModel)]="model.seoDescription"
              #seoDescription="ngModel"
              (ngModelChange)="clearBackendError(articleForm, 'seoDescription')"
            ></textarea>

            <mat-hint align="end">
              {{ model.seoDescription?.length || 0 }}/320
            </mat-hint>

            <mat-error *ngIf="seoDescription.errors?.required && seoDescription.touched">
              Opis SEO jest wymagany.
            </mat-error>

            <mat-error *ngIf="seoDescription.errors?.backend && seoDescription.touched">
              {{ seoDescription.errors.backend }}
            </mat-error>
          </mat-form-field>

          <mat-form-field>
            <mat-label>Słowa kluczowe SEO</mat-label>
            <input
              matInput
              name="seoKeywords"
              maxlength="255"
              [(ngModel)]="model.seoKeywords"
              (ngModelChange)="clearBackendError(articleForm, 'seoKeywords')"
            >
          </mat-form-field>
        </mat-card>
      </div>
    </div>
  </form>
</div>
